<template>
  <div class="custom-transfer">
    <!-- 左侧：搜索+文章列表（点击直接添加） -->
    <el-row>
      <el-col :span="11"
        ><div class="transfer-panel left-panel">
          <!-- 搜索区域 -->
          <div class="search-bar">
            <el-input
              v-model="searchKey"
              placeholder="搜索文章"
              suffix-icon="el-icon-search"
              size="small"
              clearable
              @input="handleSearch"
            />
            <i
              class="el-icon-plus"
              style="font-size: 25px; padding-left: 5px"
              @click="handleAddAll"
            ></i>
          </div>
          <!-- 文章列表（点击直接添加到右侧） -->
          <div class="article-list">
            <div
              class="article-item"
              v-for="item in filteredOptions"
              :key="item.id"
              @click="handleDirectAdd(item)"
              :class="{ added: isAdded(item.id) }"
            >
              <!-- 文字过长显示省略号 -->
              <span class="article-title">{{ item.text }}</span>
              <!-- 已添加标识 -->
              <el-icon v-if="isAdded(item.id)" class="added-icon"
                ><Check
              /></el-icon>
            </div>
            <!-- 无数据提示 -->
            <div class="empty-tip" v-if="filteredOptions.length === 0">
              暂无匹配的文章
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="2">
        <div style="display: flex; align-items: center">
          <van-icon :name="$imagePath.icon0" size="25" />
        </div>
      </el-col>
      <el-col :span="11">
        <!-- 右侧：已选列表 -->
        <div class="transfer-panel right-panel">
          <!-- 已选文章项 -->
          <div
            class="selected-item"
            v-for="(item, index) in selectedList"
            :key="item.id"
          >
            <span class="selected-title">{{ item.text }}</span>
            <!-- 移除按钮 -->
            <i class="el-icon-delete" @click="handleRemove(item, index)"></i>
          </div>
          <!-- 无已选提示 -->
          <div class="empty-tip" v-if="selectedList.length === 0">
            暂无已选文章
          </div>
        </div></el-col
      >
    </el-row>
    <CustomDialog
      title="添加文章"
      :visible.sync="dialogVisible"
      width="60%"
      @confirm="handleDialogConfirm({ handler: 'handleConfirm' }, 'export')"
    >
      <!-- 自定义弹窗内容 -->
      <template #content>
        <div class="custom-content">
          <CustomAddForm v-model="articleForm" ref="CustomAddForm" />
        </div>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
// 引入ElementUI的Check图标（已添加标识）
import { Check } from "element-ui/lib/icon";
import { mapState } from "vuex";

export default {
  name: "CustomTransfer",
  components: {
    Check,
  },
  props: {
    // 父组件传入的可选数据源（对象数组）
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    // 父组件传入的已选数据（双向绑定）
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 表单字段
      articleForm: {
        text: "",
        descrption: "",
      },
      dialogVisible: false, //对话框是否可见
      searchKey: "", // 搜索关键词
    };
  },
  computed: {
    ...mapState("article", ["ArticlePool", "selectedArticleIds"]),
    // 过滤后的左侧文章列表（搜索+排除已选）
    filteredOptions() {
      return this.options.filter((item) => {
        // 1. 搜索关键词匹配标题（忽略大小写）
        const isMatchSearch = item.text
          .toLowerCase()
          .includes(this.searchKey.toLowerCase());
        // 2. 排除已选的项（通过id判断）
        const isNotSelected = !this.value.some(
          (selected) => selected.id === item.id,
        );
        return isMatchSearch && isNotSelected;
      });
    },
    // 已选列表（双向绑定）
    selectedList: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    // 搜索文章
    handleSearch(event) {
      console.log("搜索文章了", event);
      // 触发过滤
      // this.$nextTick(() => {
      //   this.$refs.articleList.scrollTop = 0;
      // });
    },
    // 对话框确认添加文章
    async handleDialogConfirm() {
      // 从表单里拿数据
      const newArticle = this.$refs.CustomAddForm.getFormData();
      if (!newArticle.text || !newArticle.descrption) {
        this.$message.warning("请填写完整");
        return;
      }
      // 生成一个不会重复的 id（时间戳 + 随机数）
      const article = {
        id: Date.now() + Math.floor(Math.random() * 1000),
        text: newArticle.text,
        description: newArticle.descrption,
      };
      // 1. 关闭弹窗  2. 清空表单  3. 抛给父组件
      this.dialogVisible = false;
      this.$refs.CustomAddForm.resetForm();
      this.$emit("add-article", article); // <-- 关键
      console.log(
        "CustomTranster子组件点击确定按钮了",
        this.articleForm,
        article,
      );
      // 合并已选列表
      // this.selectedList = [...this.selectedList, ...this.filteredOptions];
      // // 关闭对话框
      // this.dialogVisible = false;
    },
    // 点击添加所有按钮，将左侧未选文章添加到右侧
    handleAddAll() {
      this.dialogVisible = true;
      console.log("点击添加文章了", this.filteredOptions);
      // // 过滤出未选的文章
      // const unselectedArticles = this.filteredOptions;
      // // 合并到已选列表
      // this.selectedList = [...this.selectedList, ...unselectedArticles];
    },
    // 判断文章是否已添加到右侧
    isAdded(articleId) {
      return this.selectedList.some((item) => item.id === articleId);
    },
    // 点击左侧文章直接添加到右侧
    handleDirectAdd(articleItem) {
      console.log("点击左侧文章直接添加到右侧", articleItem);
      // 防止重复添加（双重校验）
      if (this.isAdded(articleItem.id)) return;
      // 追加到已选列表
      this.selectedList = [...this.selectedList, articleItem];
      // this.$emit("handleDirectAdd", this.selectedList);
      // 可选：添加成功的提示（按需开启）
      this.$message.success(`已添加：${articleItem.text}`);
    },
    // 从右侧移除指定文章
    handleRemove(item, index) {
      console.log("点击删除按钮了", item, index, this.selectedList);
      this.selectedList.splice(index, 1);
      this.$emit("handleRemove", item, index);
    },
  },
};
</script>

<style scoped>
::v-deep.el-row {
  display: flex;
  align-items: center;
}

.el-icon-plus:hover {
  color: var(--theme-primary);
  transform: scale(1.2);
  cursor: pointer;
}
.el-icon-delete:hover {
  color: #f56c6c;
  transform: scale(1.2);
  cursor: pointer;
}
.custom-transfer {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 10px;
}

/* 通用面板样式 */
.transfer-panel {
  border-radius: 4px;
  padding: 10px;
  min-height: 150px;
  background: #fff;
}

/* 左侧面板样式 */
.left-panel {
}
.search-bar {
  display: flex;
  align-items: center;
}
/* 文章列表样式 */
.article-list {
  overflow-y: auto;
  max-height: 320px;
}
.article-item {
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.article-item:hover {
  background: #f5f7fa;
}
/* 已添加的样式（灰色背景+对勾） */
.article-item.added {
  background: #f0f9eb;
  color: #67c23a;
  cursor: not-allowed;
}
/* 文字过长省略 */
.article-title {
  display: inline-block;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
  font-size: 12px;
}
.added-icon {
  font-size: 14px;
  color: #67c23a;
}

/* 右侧面板样式 */
.right-panel {
}
.selected-header {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333;
}
.selected-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  background: #f9f9f9;
}
.selected-title {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
  font-size: 12px;
}

/* 空数据提示 */
.empty-tip {
  text-align: center;
  padding: 20px 0;
  color: #999;
  font-size: 12px;
}
</style>
